/* Pensualizei — selos de pagamento no rodapé (Store 3). Injeta uma fileira discreta de formas de pagamento do lado oposto ao copyright, sem editar o footer.liquid. Reversível: basta remover o include no meta-tags. */
(function(){
  var METHODS = ['Visa','Mastercard','Elo','Amex','Hipercard','Pix','Boleto'];
  function injectStyle(){
    if(document.getElementById('ps-pay-style')) return;
    var s = document.createElement('style');
    s.id = 'ps-pay-style';
    s.textContent =
      '.footer__column--info{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;}' +
      '.footer__payment{display:none !important;}' +
      '.ps-pay{display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin-left:auto;}' +
      '.ps-pay-chip{font-size:10px;line-height:1;letter-spacing:.04em;text-transform:uppercase;padding:5px 8px;border:1px solid rgba(255,255,255,.22);border-radius:5px;color:rgba(255,255,255,.72);white-space:nowrap;background:transparent;}' +
      '@media(max-width:749px){.footer__column--info{justify-content:center;}.ps-pay{margin-left:0;justify-content:center;width:100%;}}';
    document.head.appendChild(s);
  }
  function init(){
    var copyright = document.querySelector('.footer__copyright');
    if(!copyright || document.querySelector('.ps-pay')) return;
    injectStyle();
    var box = document.createElement('div');
    box.className = 'ps-pay';
    box.setAttribute('aria-label','Formas de pagamento aceitas');
    METHODS.forEach(function(m){
      var c = document.createElement('span');
      c.className = 'ps-pay-chip';
      c.textContent = m;
      box.appendChild(c);
    });
    copyright.parentNode.appendChild(box);
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
